import { useLanguage } from "@/contexts/LanguageContext";
import { useLocaleNavigate } from "@/hooks/useLocaleNavigate";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const FinalCta = () => {
  const { t } = useLanguage();
  const navigate = useLocaleNavigate();

  return (
    <section className="py-16 lg:py-20 bg-primary">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-primary-foreground mb-3">
          {t.finalCta.title}
        </h2>
        <p className="text-primary-foreground/80 mb-8 max-w-lg mx-auto">
          {t.finalCta.subtitle}
        </p>
        <Button
          size="lg"
          className="h-14 px-8 rounded-full text-base gap-2 bg-background text-primary hover:bg-background/90"
          onClick={() => navigate("/properties")}
        >
          {t.nav.startFree}
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </section>
  );
};

export default FinalCta;
